export function setAllConversations(data) {
  return {
    type: 'SET_ALL_CONVERSATIONS',
    payload: data,
  }
}

// TODO: update to => setConversation
export function changeDisplayName(data) {
  return {
    type: 'CHANGE_DISPLAY_NAME',
    payload: data,
  }
}
export function setConversations(data) {
  return {
    type: 'SET_CONVERSATIONS',
    payload: data,
  }
}
export function setNewAgentMessage(data) {
  return {
    type: 'SET_NEW_AGENT_MESSAGE',
    payload: data,
  }
}
export function setUpdateAgentMessageSuccess(data) {
  return {
    type: 'SET_UPDATE_AGENT_MESSAGE_SUCCESS',
    payload: data,
  }
}
export function setUpdateAgentMessageError(data) {
  return {
    type: 'SET_UPDATE_AGENT_MESSAGE_ERROR',
    payload: data,
  }
}
export function addNewUserMessage(data) {
  return {
    type: 'ADD_NEW_USER_MESSAGE',
    payload: data,
  }
}
export function setNewAiMessage(data) {
  return {
    type: 'SET_NEW_AI_MESSAGE',
    payload: data,
  }
}
export function setUIMemoScroll(data) {
  return {
    type: 'SET_UIMEMO_SCROLL',
    payload: data,
  }
}
export function deleteConversations(data) {
  return {
    type: 'DELETE_CONVERSATIONS',
    payload: data,
  }
}
export function setMessages(data) {
  return {
    type: 'SET_MESSAGES',
    payload: data,
  }
}
export const setFileDrop = (file) => {
  return {
    type: 'SET_FILE_DROP',
    payload: file,
  }
}
